import React from 'react';
import CardStack, { Highlight } from '../CardStack/CardStack';
import { Layers, CreditCard, Package } from 'lucide-react';
import Section from '../Section';
import GradualSpacingText from '../GradualSpacingText/GradualSpacingText';
import './ProblemSection.css';

const ProblemSection = () => {
    // Problem cards data
    const PROBLEM_CARDS = [
        {
            id: 0,
            name: "Unreliable Capacity",
            designation: "Operational Risk",
            icon: Layers,
            content: (
                <p>
                    Struggling with <Highlight>last-minute cancellations</Highlight> and inconsistent carrier availability.
                </p>
            ),
        },
        {
            id: 1,
            name: "Lack of Visibility",
            designation: "Supply Chain Gap",
            icon: CreditCard,
            content: (
                <p>
                    <Highlight>Blind spots</Highlight> in your shipment tracking lead to missed deadlines and unhappy customers.
                </p>
            ),
        },
        {
            id: 2,
            name: "Rising Costs",
            designation: "Budget Pressure",
            icon: Package,
            content: (
                <p>
                    Inaccessible rates and <Highlight>unpredictable pricing</Highlight> hurt your bottom line.
                </p>
            ),
        },
    ];

    return (
        <Section 
            className="problem-section reveal"
            style={{ 
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/hero2.png)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed'
            }}
        >
            <div className="problem-bg-overlay"></div>
            <div className="problem-content horizontal-layout">
                <div className="problem-summary">
                    <div className="problem-badge">Operational Challenges</div>
                    <h2 className="section-headline"><GradualSpacingText text={"Moving freight shouldn't be a headache."} /></h2>
                    <p className="problem-text">
                        Traditional logistics can be slow, opaque, and expensive. We solve those pain points with technology and dedicated capacity.
                        <span className="solution-text">We provide the reliability you deserve.</span>
                    </p>
                </div>
                <div className="problem-animation">
                    <CardStack items={PROBLEM_CARDS} />
                </div>
            </div>
        </Section>
    );
};

export default ProblemSection;